import React from 'react'
import { ColorProps } from '../../../../../../../Inspector/Sidebar/components/Color/ColorDot'

import { Container, Variable, ValueContainer, Text } from './ColorValue.styles'
import { ColorFormat } from '../../../../../../../types'
import { FormattedColorValue } from '../../../Color/FormattedColorValue'

export const ColorValue = ({
  red,
  green,
  blue,
  alpha = 1,
  format = ColorFormat.HEX,
  colorVariableName,
}: ColorProps) => {
  return (
    <Container>
      {colorVariableName ? (
        <Variable className="ColorText">
          {colorVariableName.split('/').pop()}
        </Variable>
      ) : null}

      <ValueContainer>
        <Text className="ColorText" hasColorVariable={!!colorVariableName}>
          <FormattedColorValue
            format={format}
            color={{ red, green, blue, alpha }}
          />
        </Text>
      </ValueContainer>
    </Container>
  )
}
